import { effect, inject, Injectable } from '@angular/core';
import { DictionaryService } from '@softline/core';
import { queryParam } from '@softline/application';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class BelegQueryService extends DictionaryService<unknown> {
  activatedRoute = inject(ActivatedRoute);

  queryParams = queryParam('query');
  queryParamsEffect = effect(() => {
    try {
      const queryParams = this.queryParams();
      if (!queryParams) return;
      const query = JSON.parse(atob(queryParams));
      this._dict.set(query);
    }
    catch (e) {
      console.error('[BelegQueryService] queryParamsEffect', e);
    }
  });

  constructor() {
    super();
  }
}
